<template>
  <div class="childPannel">
    <div v-if="list.length" class="childPannel-box">
      <div
        v-for="m in list"
        @click="handleClickItem(m)"
        :key="m.properties.mmsi"
        class="childPannel-box-item"
      >
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">船只名称：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.properties.name }}</span>
          </div>
        </div>
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">MMSI：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.properties.mmsi }}</span>
          </div>
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">船只类型：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.properties.type }}</span>
          </div>
        </div>
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">长度：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.properties.len }}</span>
          </div>
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">宽度：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.properties.wid }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-empty v-if="!list.length" :image-size="100" description="当前内容为空" />
    <el-pagination
      class="childPannel-pagination"
      v-else
      size="small"
      v-model:current-page="params.pageNum"
      :page-size="params.pageSize"
      background
      :pager-count="5"
      @change="getList"
      layout="prev, pager, next"
      :total="total"
    />
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, watch } from 'vue'
import { toCameraPosition } from './utils'
import { LayerPopupCtrl } from '@/components/LayerPopupCtrl'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { Cartographic, Math } from 'cesium'
import ShipPopup from '../../Popup/ShipPopup.vue'
import { getAllShipDataInfo } from '@/apiFzn'
import type { IshipAll } from '@/apiFzn/types'

const popupCtrl = LayerPopupCtrl.getInstance()
let cesiumobj: CesiumObj | null = null

const shipId = defineModel<string>('shipId')

const props = defineProps({
  showPannelKey: {
    type: String,
    default: '',
  },
  searchValue: {
    type: String,
    default: '', // 提供默认值
  },
})

const handleClickItem = async (m: IshipAll) => {
  if (!cesiumobj) cesiumobj = await CesiumObj.getInstance()
  shipId.value = m.properties.mmsi
  cesiumobj.layerManager.ship66Layer.emit('click', m.properties)
  popupCtrl.popupMap.forEach((val) => {
    val.destroy()
  })
  toCameraPosition(
    {
      lng: m.properties.longitude,
      lat: m.properties.latitude,
    },
    9000
  )
  const cartographic = Cartographic.fromDegrees(m.properties.longitude, m.properties.latitude, 0)
  popupCtrl.popup({
    viewer: cesiumobj.viewer,
    id: m.properties.mmsi,
    lnglat: [cartographic.longitude, cartographic.latitude].map(Math.toDegrees) as [number, number],
    Com: ShipPopup,
    properties: m.properties,
  })
}

const params = reactive({
  mmis: '',
  name: '',
  type: '',
  pageNum: 1,
  pageSize: 8,
})
const list = ref<IshipAll[]>([])
const total = ref(0)

const getList = () => {
  getAllShipDataInfo(params).then((res) => {
    list.value = res.rows
    total.value = res.total
  })
}

defineExpose({
  getList,
})

watch(
  () => props.searchValue,
  (newVal) => {
    params.name = newVal // 将搜索值赋给查询参数
    params.pageNum = 1 // 重置页码到第一页
  },
  { immediate: true } // 初始化时立即执行一次
)
</script>

<style lang="scss" scoped>
@import url('./childPannel.scss');
</style>
